var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.128 2.99976H7.872C7.3905 2.99976 7 3.39026 7 3.87176V7.50126H22V3.87176C22 3.39026 21.6095 2.99976 21.128 2.99976Z",
    fill: "#2D92D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5269V20.1279C7 20.6094 7.3905 20.9999 7.8715 20.9999H21.128C21.6095 20.9999 22 20.6094 22 20.1279V16.5269H7Z",
    fill: "#2150A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.50098H22V12.002H7V7.50098Z",
    fill: "#2D83D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.0022H22V16.5272H7V12.0022Z",
    fill: "#2E70C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1595 16.9998H2.8405C2.3765 16.9998 2 16.6233 2 16.1593V7.84026C2 7.37626 2.3765 6.99976 2.8405 6.99976H11.1595C11.6235 6.99976 12 7.37626 12 7.84026V16.1593C12 16.6233 11.6235 16.9998 11.1595 16.9998Z",
    fill: "#00488D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20131 9.49976L8.42831 13.1318L7.57181 9.49976H6.47831L5.59481 13.2443L4.79831 9.49976H3.82031L4.99231 14.4998H6.16831L7.02481 10.6553L7.88181 14.4998H9.00731L10.1793 9.49976H9.20131Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIcon);
export default __webpack_public_path__ + "static/media/wordIcon.2bd11fce.svg";
export { ForwardRef as ReactComponent };